import * as React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useI18n } from '@/lib/i18n';
import { Input, type InputProps } from './input';

/** Password field with a show/hide toggle. Accepts every <Input> prop except `type`. */
export const PasswordInput = React.forwardRef<HTMLInputElement, Omit<InputProps, 'type'>>(
  ({ className, ...props }, ref) => {
    const { t } = useI18n();
    const [visible, setVisible] = React.useState(false);
    return (
      <div className="relative w-full">
        <Input
          {...props}
          ref={ref}
          type={visible ? 'text' : 'password'}
          className={cn('pr-10', className)}
        />
        <button
          type="button"
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? t('ui.hidePassword') : t('ui.showPassword')}
          aria-pressed={visible}
          title={visible ? t('ui.hidePassword') : t('ui.showPassword')}
          className="absolute right-2 top-0 flex h-10 w-8 items-center justify-center text-ink-subtle hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
        >
          {visible ? <EyeOff className="h-4 w-4" aria-hidden="true" /> : <Eye className="h-4 w-4" aria-hidden="true" />}
        </button>
      </div>
    );
  },
);
PasswordInput.displayName = 'PasswordInput';
